import { merge } from '@inpart-io/devtools';
import { getSessionModule, SESSION_MODULE } from '@inpart-io/devtools-vue';
import { tenantsManager, usersManager, userTenantAccessesManager } from '@inpart-io/padme-iap';

import { store } from '..';
import { getters } from './getters';

const sessionModuleInstance = merge(getSessionModule(tenantsManager, usersManager, userTenantAccessesManager), { getters });
store.registerModule(SESSION_MODULE, sessionModuleInstance);

export { SESSION_MODULE };
